import { EventEmitter } from 'events';

import Dispatcher from './dispatcher';

class EventStore extends EventEmitter {
    constructor() {
        super();
        this.action = null;
        this.onAdd = this.onAdd.bind(this);
        this.onClose = this.onClose.bind(this);
        Dispatcher.addListener('PICTURE_ADDED', this.onAdd);
    }

    onAdd(action) {
        console.log(action);
        this.action = action;
        this.emit('CHANGE', action);
    }

    onClose() {
        this.action = null;
        this.emit('CHANGE');
    }

    get() {
        return this.action;
    }
}

export default new EventStore();
